import { __decorate } from 'tslib';
import { ReactWrapperComponent, AngularReact, registerElement } from '@angular-react/core';
import * as i0 from '@angular/core';
import { TemplateRef, Directive, ContentChild, Input, ContentChildren, EventEmitter, Component, ChangeDetectionStrategy, ViewChild, Output, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ChangeableItemsDirective, mergeItemChanges } from '@angular-react/fabric/lib/components/core';
import { getDataAttributes, omit, Styled } from '@angular-react/fabric/lib/utils';
import { ContextualMenuItemDirective, FabContextualMenuModule } from '@angular-react/fabric/lib/components/contextual-menu';
import { CommonModule } from '@angular/common';
import { CommandBar } from '@fluentui/react/lib/CommandBar';

// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Wrapper directive to allow rendering a custom item to a CommandBarItem.
 */
class CommandBarItemRenderDirective {
}
/** @nocollapse */ CommandBarItemRenderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemRenderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarItemRenderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarItemRenderDirective, selector: "fab-command-bar-item > render", queries: [{ propertyName: "templateRef", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemRenderDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar-item > render' }]
        }], propDecorators: { templateRef: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });
/**
 * Wrapper directive to allow rendering a custom icon to a CommandBarItem.
 */
class CommandBarItemRenderIconDirective {
}
/** @nocollapse */ CommandBarItemRenderIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemRenderIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarItemRenderIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarItemRenderIconDirective, selector: "fab-command-bar-item > render-icon", queries: [{ propertyName: "templateRef", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemRenderIconDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar-item > render-icon' }]
        }], propDecorators: { templateRef: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });
class CommandBarItemDirective extends ContextualMenuItemDirective {
    constructor(elementRef) {
        super(elementRef);
    }
}
/** @nocollapse */ CommandBarItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarItemDirective, selector: "fab-command-bar-item", inputs: { iconOnly: "iconOnly", tooltipHostProps: "tooltipHostProps", buttonStyles: "buttonStyles", cacheKey: "cacheKey", renderedInOverflow: "renderedInOverflow", commandBarButtonAs: "commandBarButtonAs" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar-item' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { iconOnly: [{
                type: Input
            }], tooltipHostProps: [{
                type: Input
            }], buttonStyles: [{
                type: Input
            }], cacheKey: [{
                type: Input
            }], renderedInOverflow: [{
                type: Input
            }], commandBarButtonAs: [{
                type: Input
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
class CommandBarItemsDirectiveBase extends ChangeableItemsDirective {
    get items() {
        return (this.directiveItems &&
            this.directiveItems.map((directiveItem) => (Object.assign(Object.assign(Object.assign({}, directiveItem), getDataAttributes(directiveItem.elementRef.nativeElement, true)), { onClick: (ev, item) => {
                    directiveItem.click.emit({
                        ev: ev && ev.nativeEvent,
                        item: item,
                    });
                } }))));
    }
}
class CommandBarItemsDirective extends CommandBarItemsDirectiveBase {
}
/** @nocollapse */ CommandBarItemsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemsDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarItemsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarItemsDirective, selector: "fab-command-bar > items", queries: [{ propertyName: "directiveItems", predicate: CommandBarItemDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarItemsDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar > items' }]
        }], propDecorators: { directiveItems: [{
                type: ContentChildren,
                args: [CommandBarItemDirective]
            }] } });
class CommandBarFarItemsDirective extends CommandBarItemsDirectiveBase {
}
/** @nocollapse */ CommandBarFarItemsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarFarItemsDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarFarItemsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarFarItemsDirective, selector: "fab-command-bar > far-items", queries: [{ propertyName: "directiveItems", predicate: CommandBarItemDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarFarItemsDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar > far-items' }]
        }], propDecorators: { directiveItems: [{
                type: ContentChildren,
                args: [CommandBarItemDirective]
            }] } });
class CommandBarOverflowItemsDirective extends CommandBarItemsDirectiveBase {
}
/** @nocollapse */ CommandBarOverflowItemsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarOverflowItemsDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ CommandBarOverflowItemsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: CommandBarOverflowItemsDirective, selector: "fab-command-bar > overflow-items", queries: [{ propertyName: "directiveItems", predicate: CommandBarItemDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: CommandBarOverflowItemsDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-command-bar > overflow-items' }]
        }], propDecorators: { directiveItems: [{
                type: ContentChildren,
                args: [CommandBarItemDirective]
            }] } });

let FabCommandBarComponent = class FabCommandBarComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer, ngZone) {
        super(elementRef, changeDetectorRef, renderer, { ngZone, setHostDisplay: true });
        this.onDataReduced = new EventEmitter();
        this.onDataGrown = new EventEmitter();
        this._subscriptions = [];
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (changes['items'] &&
            changes['items'].previousValue !== changes['items'].currentValue &&
            changes['items'].currentValue)
            this._createTransformedItems(changes['items'].currentValue);
        if (changes['farItems'] &&
            changes['farItems'].previousValue !== changes['farItems'].currentValue &&
            changes['farItems'].currentValue)
            this._createTransformedFarItems(changes['farItems'].currentValue);
        if (changes['overflowItems'] &&
            changes['overflowItems'].previousValue !== changes['overflowItems'].currentValue &&
            changes['overflowItems'].currentValue)
            this._createTransformedOverflowItems(changes['overflowItems'].currentValue);
        super.ngOnChanges(changes);
    }
    ngAfterContentInit() {
        if (this.itemsDirective)
            this._initDirective(this.itemsDirective, 'items');
        if (this.farItemsDirective)
            this._initDirective(this.farItemsDirective, 'farItems');
        if (this.overflowItemsDirective)
            this._initDirective(this.overflowItemsDirective, 'overflowItems');
        super.ngAfterContentInit();
    }
    ngOnDestroy() {
        this._subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    _initDirective(directive, itemsPropertyKey) {
        const transformItemsFunc = (directive instanceof CommandBarItemsDirective && (newItems => this._createTransformedItems(newItems))) ||
            (directive instanceof CommandBarFarItemsDirective && (newItems => this._createTransformedFarItems(newItems))) ||
            (directive instanceof CommandBarOverflowItemsDirective &&
                (newItems => this._createTransformedOverflowItems(newItems)));
        null;
        if (!transformItemsFunc) {
            throw new Error('Invalid directive given');
        }
        const setItems = (mapper) => {
            this[itemsPropertyKey] = mapper(this[itemsPropertyKey]);
            transformItemsFunc(this[itemsPropertyKey]);
            this.markForCheck();
        };
        // Initial items
        setItems(() => directive.items);
        // Subscribe to adding/removing items
        this._subscriptions.push(directive.onItemsChanged.subscribe((newItems) => {
            setItems(() => newItems.map(directive => directive));
        }));
        // Subscribe for existing items changes
        this._subscriptions.push(directive.onChildItemChanged.subscribe(({ key, changes }) => {
            setItems(items => items.map(item => (item.key === key ? mergeItemChanges(item, changes) : item)));
            this.markForCheck();
        }));
    }
    _createTransformedItems(newItems) {
        this.transformedItems_ = newItems.map(item => this._transformCommandBarItemOptionsToProps(item));
    }
    _createTransformedFarItems(newItems) {
        this.transformedFarItems_ = newItems.map(item => this._transformCommandBarItemOptionsToProps(item));
    }
    _createTransformedOverflowItems(newItems) {
        this.transformedOverflowItems_ = newItems.map(item => this._transformCommandBarItemOptionsToProps(item));
    }
    _transformCommandBarItemOptionsToProps(itemOptions) {
        const sharedProperties = omit(itemOptions, 'renderIcon', 'render');
        // Legacy render mode is used for the icon because otherwise the icon is to the right of the text (instead of the usual left)
        const iconRenderer = this.createInputJsxRenderer(itemOptions.renderIcon, { legacyRenderMode: true });
        const renderer = this.createInputJsxRenderer(itemOptions.render);
        // @ts-ignore
        return Object.assign({}, sharedProperties, iconRenderer && {
            onRenderIcon: (item) => iconRenderer({ contextualMenuItem: item }),
        }, renderer &&
            { onRender: (item, dismissMenu) => renderer({ item, dismissMenu }) });
    }
};
/** @nocollapse */ FabCommandBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabCommandBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabCommandBarComponent, selector: "fab-command-bar", inputs: { componentRef: "componentRef", overflowButtonProps: "overflowButtonProps", overflowButtonAs: "overflowButtonAs", buttonAs: "buttonAs", shiftOnReduce: "shiftOnReduce", className: "className", ariaLabel: "ariaLabel", styles: "styles", theme: "theme", onReduceData: "onReduceData", onGrowData: "onGrowData", items: "items", farItems: "farItems", overflowItems: "overflowItems" }, outputs: { onDataReduced: "onDataReduced", onDataGrown: "onDataGrown" }, queries: [{ propertyName: "itemsDirective", first: true, predicate: CommandBarItemsDirective, descendants: true, static: true }, { propertyName: "farItemsDirective", first: true, predicate: CommandBarFarItemsDirective, descendants: true, static: true }, { propertyName: "overflowItemsDirective", first: true, predicate: CommandBarOverflowItemsDirective, descendants: true, static: true }], viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabCommandBar"], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: `
    <CommandBar
      #reactNode
      [componentRef]="componentRef"
      [items]="transformedItems_"
      [farItems]="transformedFarItems_"
      [overflowItems]="transformedOverflowItems_"
      [overflowButtonProps]="overflowButtonProps"
      [overflowButtonAs]="overflowButtonAs"
      [buttonAs]="buttonAs"
      [shiftOnReduce]="shiftOnReduce"
      [className]="className"
      [ariaLabel]="ariaLabel"
      [styles]="styles"
      [theme]="theme"
      [ReduceData]="onReduceData"
      [GrowData]="onGrowData"
      (onDataReduced)="(onDataReduced)"
      (onDataGrown)="(onDataGrown)"
    >
    </CommandBar>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabCommandBarComponent = __decorate([
    AngularReact(),
    Styled('FabCommandBarComponent')
], FabCommandBarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-command-bar',
                    exportAs: 'fabCommandBar',
                    template: `
    <CommandBar
      #reactNode
      [componentRef]="componentRef"
      [items]="transformedItems_"
      [farItems]="transformedFarItems_"
      [overflowItems]="transformedOverflowItems_"
      [overflowButtonProps]="overflowButtonProps"
      [overflowButtonAs]="overflowButtonAs"
      [buttonAs]="buttonAs"
      [shiftOnReduce]="shiftOnReduce"
      [className]="className"
      [ariaLabel]="ariaLabel"
      [styles]="styles"
      [theme]="theme"
      [ReduceData]="onReduceData"
      [GrowData]="onGrowData"
      (onDataReduced)="(onDataReduced)"
      (onDataGrown)="(onDataGrown)"
    >
    </CommandBar>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { itemsDirective: [{
                type: ContentChild,
                args: [CommandBarItemsDirective, { static: true }]
            }], farItemsDirective: [{
                type: ContentChild,
                args: [CommandBarFarItemsDirective, { static: true }]
            }], overflowItemsDirective: [{
                type: ContentChild,
                args: [CommandBarOverflowItemsDirective, { static: true }]
            }], reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], componentRef: [{
                type: Input
            }], overflowButtonProps: [{
                type: Input
            }], overflowButtonAs: [{
                type: Input
            }], buttonAs: [{
                type: Input
            }], shiftOnReduce: [{
                type: Input
            }], className: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], styles: [{
                type: Input
            }], theme: [{
                type: Input
            }], onReduceData: [{
                type: Input
            }], onGrowData: [{
                type: Input
            }], items: [{
                type: Input
            }], farItems: [{
                type: Input
            }], overflowItems: [{
                type: Input
            }], onDataReduced: [{
                type: Output
            }], onDataGrown: [{
                type: Output
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
// Dummy action to force OverflowSetCss to load and not be tree-shaken away.
// noop(OverflowSetCss);
const components = [
    FabCommandBarComponent,
    CommandBarItemsDirective,
    CommandBarFarItemsDirective,
    CommandBarOverflowItemsDirective,
    CommandBarItemDirective,
    CommandBarItemRenderDirective,
    CommandBarItemRenderIconDirective,
];
class FabCommandBarModule {
    constructor() {
        // Add any React elements to the registry (used by the renderer).
        registerElement('CommandBar', () => CommandBar);
    }
}
/** @nocollapse */ FabCommandBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabCommandBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarModule, declarations: [FabCommandBarComponent,
        CommandBarItemsDirective,
        CommandBarFarItemsDirective,
        CommandBarOverflowItemsDirective,
        CommandBarItemDirective,
        CommandBarItemRenderDirective,
        CommandBarItemRenderIconDirective], imports: [CommonModule, FabContextualMenuModule], exports: [FabCommandBarComponent,
        CommandBarItemsDirective,
        CommandBarFarItemsDirective,
        CommandBarOverflowItemsDirective,
        CommandBarItemDirective,
        CommandBarItemRenderDirective,
        CommandBarItemRenderIconDirective, FabContextualMenuModule] });
/** @nocollapse */ FabCommandBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarModule, imports: [[CommonModule, FabContextualMenuModule], FabContextualMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCommandBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FabContextualMenuModule],
                    declarations: components,
                    exports: [...components, FabContextualMenuModule],
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

// Copyright (c) Microsoft Corporation. All rights reserved.

/**
 * Generated bundle index. Do not edit.
 */

export { CommandBarFarItemsDirective, CommandBarItemDirective, CommandBarItemRenderDirective, CommandBarItemRenderIconDirective, CommandBarItemsDirective, CommandBarItemsDirectiveBase, CommandBarOverflowItemsDirective, FabCommandBarComponent, FabCommandBarModule };
